module.exports = __webpack_public_path__ + "07476be9bf76f91c962ffa11e21e014b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/lankenau04.jpg
// module id = 801
// module chunks = 0